import { Plus } from '@phosphor-icons/react';
import { t } from 'i18next';
import { cloneElement, ReactElement, useMemo, useState } from 'react';

import { Button } from 'core/components';
import { IPricingProfile, IPricingProfileCostingCalculation } from 'pricing/types';
import { Color } from 'theme/enums';

import { UpsertPricingProfileCostingCalculation } from './UpsertPricingProfileCostingCalculation';

interface IProps {
  pricingProfile: IPricingProfile;
  costingCalculation?: IPricingProfileCostingCalculation;
  buttonElement?: ReactElement;
  onSubmitSuccess: () => void;
  onRemoveSuccess?: () => void;
  disabled?: boolean;
}

export const UpsertPricingProfileCostingCalculationButton = ({
  pricingProfile,
  costingCalculation,
  buttonElement,
  onSubmitSuccess,
  onRemoveSuccess,
  disabled = false,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const buttonLabel = t('buttonLabelAddCostingCalculation');

  const button = useMemo(() => {
    if (buttonElement) {
      return cloneElement(buttonElement, {
        onClick: disabled ? undefined : () => setIsOpen(true),
      });
    }

    return (
      <Button
        text={buttonLabel}
        color={Color.SUCCESS}
        startDecorator={<Plus />}
        onClick={() => setIsOpen(true)}
        disabled={disabled}
      />
    );
  }, [buttonElement, buttonLabel, disabled]);

  return (
    <>
      {button}

      {isOpen && (
        <UpsertPricingProfileCostingCalculation
          pricingProfile={pricingProfile}
          pricingProfileCostingCalculation={costingCalculation}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          onSubmitSuccess={onSubmitSuccess}
          onRemoveSuccess={onRemoveSuccess}
        />
      )}
    </>
  );
};
